// src/App.js
/**
 * Route table for the app. Each route renders one self-contained options
 * screen; there is no shared layout or chrome between them.
 */
import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import OptionsGraphWithMultiStrikeSlider from './OptionsGraphWithMultiStrikeSlider';
import OptionsTableWithMultiStrikes from './OptionsTableWithMultiStrikes';
import OptionsForecastChart from './OptionsForecastChart';
import OptionsGraphForecast from './OptionsGraphForecast';

const App = () => (
  <Routes>
    {/* Default screen: payoff graph with a multi-strike range slider. */}
    <Route path="/" element={<OptionsGraphWithMultiStrikeSlider />} />
    {/* Tabular view of the same multi-strike position data. */}
    <Route path="/table" element={<OptionsTableWithMultiStrikes />} />
    {/* Standalone forecast chart (no position data, chart only). */}
    <Route path="/forecast_chart" element={<OptionsForecastChart />} />
    {/* Full forecast screen: payoff graph plus forward-looking projections. */}
    <Route path="/forecast" element={<OptionsGraphForecast />} />
    {/* Unknown paths fall back to the default screen rather than 404ing. */}
    <Route path="*" element={<Navigate to="/" />} />
  </Routes>
);

export default App;
